import React from 'react'
import { Route, Router } from 'react-router'

import { getHistory } from 'lib/history'
import {
  track,
  TrackImpression,
  withContextualizedTracking,
} from 'lib/analytics'

import { DiaperCalculatorShape, RoutingShape } from './prop-types'
import { DiaperCalculatorForm } from './diaper-calculator-form'
import { DiaperCalculatorResultGoBigOrGoHome } from './diaper-calculator-result-go-big-or-go-home'
import { DiaperCalculatorResultJustTheBasics } from './diaper-calculator-result-just-the-basics'
import { DiaperCalculatorResultSensibleStart } from './diaper-calculator-result-sensible-start'
import { DiaperCalculatorProducts } from './diaper-calculator-products'

const ImpressionTrackedResultPage = withContextualizedTracking()(
  ({ result, ...restProps }) => (
    <TrackImpression
      eventProperties={{
        event: track.diaperCalculatorResultViewed,
        eventLocation: track.EventLocation.DIAPER_CALCULATOR,
        diaperCalculatorResultSlug: result.slug,
        diaperCalculatorResultName: result.name,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  )
)

const ImpressionTrackedFormPage = withContextualizedTracking()(
  ({ children }) => (
    <TrackImpression
      eventProperties={{
        event: track.diaperCalculatorFormViewed,
        eventLocation: track.EventLocation.DIAPER_CALCULATOR,
      }}
    >
      {children}
    </TrackImpression>
  )
)

export const DiaperCalculatorApp = ({ routing, diaperCalculator }) => {
  const history = getHistory({
    path: routing.path,
    useRouter: true,
  })

  const { resultContent, questionContent, featuredProducts, result } =
    diaperCalculator

  const DiaperCalculatorProductsComponent = () => (
    <DiaperCalculatorProducts products={featuredProducts} />
  )

  return (
    <Router history={history}>
      <Route path="/">
        <Route
          path={routing.basePath}
          component={(props) => (
            <ImpressionTrackedFormPage>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <DiaperCalculatorForm questions={questionContent} {...props} />
            </ImpressionTrackedFormPage>
          )}
        />
        <Route
          path={`${routing.basePath}/`}
          component={(props) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <ImpressionTrackedResultPage result={result} {...props} />
          )}
        >
          <Route
            path={resultContent.goBigOrGoHome.slug}
            component={() => (
              <DiaperCalculatorResultGoBigOrGoHome
                DiaperCalculatorProducts={DiaperCalculatorProductsComponent}
              />
            )}
          />
          <Route
            path={resultContent.justTheBasics.slug}
            component={() => (
              <DiaperCalculatorResultJustTheBasics
                DiaperCalculatorProducts={DiaperCalculatorProductsComponent}
              />
            )}
          />
          <Route
            path={resultContent.sensibleStart.slug}
            component={() => (
              <DiaperCalculatorResultSensibleStart
                DiaperCalculatorProducts={DiaperCalculatorProductsComponent}
              />
            )}
          />
        </Route>
      </Route>
    </Router>
  )
}

DiaperCalculatorApp.propTypes = {
  routing: RoutingShape.isRequired,
  diaperCalculator: DiaperCalculatorShape.isRequired,
}
